import React from 'react';
import { DEFAULT_TAX_RATE } from '../../types/billing';

interface TaxCalculatorProps {
  taxRate: number;
  onTaxRateChange: (rate: number) => void;
  subtotal: number;
  readOnly?: boolean;
}

export const TaxCalculator: React.FC<TaxCalculatorProps> = ({
  taxRate,
  onTaxRateChange,
  subtotal,
  readOnly = false,
}) => {
  const taxAmount = subtotal * (taxRate / 100);

  return (
    <div className="flex items-center gap-3 p-3 bg-slate-950 rounded-lg border border-slate-800">
      <label className="text-xs text-slate-400 whitespace-nowrap">Tax Rate</label>
      {readOnly ? (
        <span className="text-xs text-slate-300 font-semibold">{taxRate}%</span>
      ) : (
        <input
          type="number"
          min={0}
          max={100}
          step={0.5}
          value={taxRate}
          onChange={(e) => onTaxRateChange(parseFloat(e.target.value) || 0)}
          className="w-20 px-2 py-1 bg-slate-800 border border-slate-700 rounded text-xs text-slate-200 focus:outline-none focus:border-sky-500"
        />
      )}
      <span className="text-xs text-slate-400">%</span>
      <div className="flex-1" />
      <span className="text-xs text-slate-500">Tax Amount:</span>
      <span className="text-xs text-slate-300 font-medium">Rs {taxAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
    </div>
  );
};
